export default __webpack_public_path__ + "static/media/clustifyR_alt.34aa9eaf.png";